// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__2v6BV","description":"PatientConsentPreview_description__3qdVY"};